import { Flex, ButtonChip } from 'pcln-design-system';
import React, { useState } from 'react';
import analytics from './analytics/analytics';
export const QuickActionsChips = props => {
  const {
    submitQuickActionMessage,
    hasOtherMessage,
    quickActions,
    isSeparatorMsg
  } = props;
  const [isQuickActionsDisplayed, setQuickActionsDisplayedValue] = useState(true);
  if (!isSeparatorMsg && (!quickActions || !quickActions.length || hasOtherMessage || !isQuickActionsDisplayed)) {
    return null;
  }
  return React.createElement(Flex, {
    flexDirection: 'row',
    alignItems: 'center',
    p: 2,
    flexWrap: 'nowrap',
    style: {
      overflow: 'auto'
    }
  }, quickActions.map((action, i) => React.createElement(Flex, {
    key: `quick-action-button-${i}`,
    my: 2,
    mx: 1,
    alignItems: 'center'
  }, React.createElement(ButtonChip, {
    size: 'md',
    label: action.label,
    color: 'text.base',
    onClick: function () {
      submitQuickActionMessage(action);
      setQuickActionsDisplayedValue(false);
      analytics.log({
        label: 'dynamicQuickActions',
        message: 'QUICK_ACTION_CHIPS_CLICKED',
        content: action.label
      });
    }
  }))));
};